import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useParams } from "react-router-dom";
import { TicketPdfButton } from "../components/frontrow/TicketPdfButton";

// This page reads authorised event data directly. Dismissing a dashboard card
// must not break the private link already saved in a parent's calendar.
export default function EventTickets() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    let live = true;
    setData(null); setFailed(false);
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/events/${encodeURIComponent(id)}/tickets`)
      .then(r => { if (live) setData(r.data); })
      .catch(() => { if (live) setFailed(true); });
    return () => { live = false; };
  }, [id]);
  return <main className="min-h-screen bg-[#FAFAF8] px-5 py-8 text-[#172033]">
    <div className="mx-auto max-w-lg">
      <Link to="/" className="underline">Back to FrontRow</Link>
      <h1 className="mt-5 text-2xl font-semibold">{data?.event_name || "Event tickets"}</h1>
      {failed ? <p role="alert" className="mt-4">These tickets aren’t available to this account. Check that you’re signed into the right family.</p>
        : !data ? <p className="mt-4">Loading tickets…</p>
        : <>
          {data.tickets.length ? <ul className="mt-4 space-y-3">
            {data.tickets.map(ticket => <li key={ticket.resource_id}>
              <TicketPdfButton eventId={id} resourceId={ticket.resource_id}
                filename={ticket.attachment_name} label={ticket.label} />
            </li>)}
          </ul> : <p className="mt-4">No PDF tickets are attached yet. Tickets received later will appear here.</p>}
        </>}
    </div>
  </main>;
}
